import dayjs, { Dayjs } from 'dayjs';
import { Timestamp } from '../data.js';

import relativeTime from 'dayjs/plugin/relativeTime.js';

dayjs.extend(relativeTime);

export const month = [
	{
		id: 1,
		name: 'January',
		days: 31,
	},
	{
		id: 2,
		name: 'February',
		days: 29,
	},
	{
		id: 3,
		name: 'March',
		days: 31,
	},
	{
		id: 4,
		name: 'April',
		days: 30,
	},
	{
		id: 5,
		name: 'May',
		days: 31,
	},
	{
		id: 6,
		name: 'June',
		days: 30,
	},
	{
		id: 7,
		name: 'July',
		days: 31,
	},
	{
		id: 8,
		name: 'August',
		days: 31,
	},
	{
		id: 9,
		name: 'September',
		days: 30,
	},
	{
		id: 10,
		name: 'October',
		days: 31,
	},
	{
		id: 11,
		name: 'November',
		days: 30,
	},
	{
		id: 12,
		name: 'December',
		days: 31,
	},
];


export const years = [1920, 1921, 1922, 1923, 1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935, 1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021];


export function formatTimestamp(t: Timestamp | Dayjs) {
	const now = dayjs();
	const d = dayjs(t);
	if (d.isAfter(now.subtract(7, 'day'))) return d.fromNow();
	if (d.isAfter(now.subtract(250, 'day'))) return d.format('MMM DD');
	return d.format('MMM DD, YYYY');
}
